import NavBar from './NavBar';

export default {
  install(Vue) {
    Vue.component('nav-bar', NavBar);
  },
};
